import { motion } from "framer-motion";
import { ChevronDown } from "lucide-react";

export function VisionHero() {
  return (
    <section data-testid="vision-hero" className="relative min-h-[92vh] flex items-center overflow-hidden bg-grid-tech">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,rgba(255,136,0,0.09),transparent_60%)]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom_left,rgba(0,230,118,0.05),transparent_55%)]" />

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-32 pb-24 w-full text-center">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7 }}
          className="font-mono-tech text-xs sm:text-sm tracking-[0.4em] text-[#00B0FF] uppercase mb-6"
        >
          LaunchLab — Vision
        </motion.p>
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, delay: 0.15 }}
          className="font-display text-4xl sm:text-6xl lg:text-7xl font-extrabold tracking-tight leading-[1.04]"
          data-testid="vision-hero-headline"
        >
          <span className="text-gradient-hero">BUILDING A STRONGER INDIA,</span>
          <br />
          <span className="text-gradient-india">ONE BUSINESS AT A TIME.</span>
        </motion.h1>
        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, delay: 0.35 }}
          className="mt-8 text-base sm:text-lg text-slate-300 leading-relaxed max-w-3xl mx-auto"
          data-testid="vision-hero-subtext"
        >
          LaunchLab's vision is to create an ecosystem where ideas are not left as ideas —
          where every entrepreneur with a meaningful idea has access to the knowledge,
          technology, strategy, branding, resources and support required to transform that
          idea into a real business.
        </motion.p>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.85, delay: 0.5 }}
          className="mt-10 flex flex-wrap justify-center gap-3"
          data-testid="vision-hero-chips"
        >
          {["Entrepreneurs", "Startups", "Businesses", "Innovators", "Job Creators"].map((t, i) => (
            <span
              key={t}
              className="glass px-5 py-2.5 rounded-full font-display font-semibold text-sm text-white"
              style={{ borderColor: ["#FF880066", "#00B0FF66", "#00E67666", "#FF880066", "#00B0FF66"][i] }}
            >
              {t}
            </span>
          ))}
        </motion.div>
        <motion.p
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 0.7 }}
          className="mt-8 font-mono-tech text-[11px] tracking-[0.3em] text-slate-500 uppercase"
        >
          A new generation of builders
        </motion.p>
      </div>

      <a
        href="#vision-bigger"
        data-testid="vision-scroll-down"
        aria-label="Scroll to the bigger vision"
        className="absolute bottom-7 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-1.5 text-slate-500 hover:text-[#FF8800] transition-colors"
      >
        <span className="font-mono-tech text-[9px] tracking-[0.35em] uppercase">Scroll</span>
        <ChevronDown className="w-5 h-5 animate-bounce" />
      </a>

      <div className="absolute bottom-0 left-0 right-0 h-40 bg-gradient-to-b from-transparent to-[#06080E] pointer-events-none" />
    </section>
  );
}
